const ScrollAnimations = () => {

  const isHiddenClass = '--is-hidden';
  const isScrolledClass = '--is-scrolled';
  const isVisibleClass = '--is-visible';

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  const header = document.getElementsByClassName('js-site-header')[0];

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    if (curScroll > window.innerHeight + 200) {
      header.classList.add(isScrolledClass);
    }

    else if (curScroll <= window.innerHeight + 200) {
      header.classList.remove(isScrolledClass);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (direction === 2) { 
      header.classList.add(isHiddenClass);
      prevDirection = direction;
    }

    else if (direction === 1) {
      header.classList.remove(isHiddenClass);
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);
};

export default ScrollAnimations;
